export default __webpack_public_path__ + "static/allProjects5-be9a0effb95fd1c6a58bb099984bf0c2.png";